var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampanha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.173,
    height: 54.042,
    viewBox: "0 0 51.173 54.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campanha",
    transform: "translate(-13.588 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_854",
    "data-name": "Grupo 854",
    transform: "translate(13.588 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1424",
    "data-name": "Caminho 1424",
    d: "M42.09.528a1.055,1.055,0,0,0-1.969.557,15.394,15.394,0,0,1-4.249,11.1A1.055,1.055,0,1,0,37.4,13.636a17.484,17.484,0,0,0,4.576-9.078L57.056,30.673a17.588,17.588,0,0,0-14.846,1.291l-7.058,4.075-8.776-15.2,2.944-1.7a1.055,1.055,0,0,0-1.056-1.828l-9.236,5.332A10.888,10.888,0,0,0,28.213,42.3C30.049,44,36.656,50.15,40.53,53.759a1.055,1.055,0,0,0,1.247.142l5.994-3.461a1.055,1.055,0,0,0,.191-1.687L36.243,37.847l7.023-4.055a15.48,15.48,0,0,1,15.865.22A1.055,1.055,0,0,0,60.6,32.585ZM16.873,36.459a8.786,8.786,0,0,1,3.212-11.988l4.464-2.577,8.77,15.19-5.3,3.017A8.788,8.788,0,0,1,16.873,36.459ZM41.4,51.682c-3.555-3.311-8.88-8.265-11.148-10.375l4.081-2.356L45.479,49.326Z",
    transform: "translate(-13.588 0)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1425",
    "data-name": "Caminho 1425",
    d: "M412.647,98.744a1.055,1.055,0,0,0,1.442.386l4.115-2.376a1.055,1.055,0,1,0-1.055-1.828L413.033,97.3A1.055,1.055,0,0,0,412.647,98.744Z",
    transform: "translate(-370.4 -84.781)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1426",
    "data-name": "Caminho 1426",
    d: "M389.635,46a1.055,1.055,0,0,0,1.442-.386l2.271-3.933a1.055,1.055,0,1,0-1.828-1.055l-2.271,3.933A1.055,1.055,0,0,0,389.635,46Z",
    transform: "translate(-349.471 -35.867)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1427",
    "data-name": "Caminho 1427",
    d: "M440.983,157.519h-4.542a1.055,1.055,0,1,0,0,2.111h4.542a1.055,1.055,0,1,0,0-2.111Z",
    transform: "translate(-390.865 -140.893)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_15",
    "data-name": "Elipse 15",
    cx: 1.055,
    cy: 1.055,
    r: 1.055,
    transform: "translate(18.263 14.793)",
    fill: "#640000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampanha);
export default __webpack_public_path__ + "static/media/campanha.9e982e74e6c20d1f75c0f0dbe4db8b98.svg";
export { ForwardRef as ReactComponent };